import React, { Component } from "react";
import ImageGallery from 'react-image-gallery';
import { getUrls } from '../../apis/widen';
import LoaderSection from './loader-section.jsx';
import { productFallbackImage } from '../../config.json';
import { downloadImg } from '../../utils/index';
import toast from '../../components/toast';


class PhotoGallery extends Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            galleryItems: [],
            isLoading: false,
            url: props.url,
            title: props.title,
            desc: props.desc,
            position: props.position,
            bullets: props.bullets === "True" ? true : false
        }

        this.downloadImage = this.downloadImage.bind(this);
    }

    componentDidMount() {

        this.setState({
            isLoading: true
        });

        const params = {
            url: `${this.state.url}&limit=100`
        };

        getUrls(params)
            .then(data => {
                console.log(data);
                this.setState({
                    items: data,
                    isLoading: false
                }, () => {
                    this.createGalleryObjects();
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
            });
    }

    downloadImage(src, title) {
        if (!src) {
            toast.error('There was a problem downloading this image');
        }

        title = !title ? 'VFS_Photo_Gallery' : title;

        downloadImg(src, title)
            .then(res => {
                toast.success('Success');
            })
            .catch(error => {
                console.log(error);
                toast.error('There was a problem downloading this image');
            });
    }

    _customRenderImg(item) {
        let content;
        content = <div className="img-gallery-img">
            <img className='image-gallery-image'
                src={item.original}
                alt={item.originalAlt}
                srcSet={item.srcSet}
                sizes={item.sizes}
                onLoad={this.props.onImageLoad} />
            <a title="Download Image" className="download-img-gallery" onClick={() => this.downloadImage(item.download, this.props.title)}></a>
        </div>;

        if (!item.description && item.originalTitle) {
            content = <div className="img-gallery-content-container">
                <div className="img-gallery-img">
                    <img className='image-gallery-image'
                        src={item.original}
                        alt={item.originalAlt}
                        srcSet={item.srcSet}
                        sizes={item.sizes}
                        onLoad={this.props.onImageLoad} />
                    <a title="Download Image" className="download-img-gallery" onClick={() => this.downloadImage(item.download, this.props.title)}></a>
                </div>

                <div className="img-gallery-content-inner">
                    <span className='image-gallery-description'>
                        <h4 className="image-gallery-title">{item.originalTitle}</h4>
                    </span>
                </div>
            </div>;
        }

        if (item.description && !item.originalTitle) {
            content = <div className="img-gallery-content-container">
                <div className="img-gallery-img">
                    <img className='image-gallery-image'
                        src={item.original}
                        alt={item.originalAlt}
                        srcSet={item.srcSet}
                        sizes={item.sizes}
                        onLoad={this.props.onImageLoad} />
                    <a title="Download Image" className="download-img-gallery" onClick={() => this.downloadImage(item.download, this.props.title)}></a>
                </div>

                <div className="img-gallery-content-inner">
                    <span className='image-gallery-description'>
                        <p className="image-gallery-desc">{item.description}</p>
                    </span>
                </div>
            </div>;
        }

        if (item.description && item.originalTitle) {
            content = <div className="img-gallery-content-container">
                <div className="img-gallery-img">
                    <img className='image-gallery-image'
                        src={item.original}
                        alt={item.originalAlt}
                        srcSet={item.srcSet}
                        sizes={item.sizes}
                        onLoad={this.props.onImageLoad} />
                    <a title="Download Image" className="download-img-gallery" onClick={() => this.downloadImage(item.download, this.props.title)}></a>
                </div>

                <div className="img-gallery-content-inner">
                    <span className='image-gallery-description'>
                        <h4 className="image-gallery-title">{item.originalTitle}</h4>
                        <p className="image-gallery-desc">{item.description}</p>
                    </span>
                </div>
            </div>;
        }

        return (
            content
        );
    }

    createGalleryObjects() {
        this.state.items.map((item) => {
            const asset = item.assetType === "PDF"
                ? {
                    original: item.pdfPreview,
                    thumbnail: item.pdfPreview,
                    originalAlt: item.fileName,
                    originalTitle: item.fileName,
                    thumbnailAlt: item.fileName,
                    description: item.description,
                    download: item.fullDownload
                }
                : {
                    original: item.landscapeEmbed,
                    thumbnail: item.medThumbnail,
                    originalAlt: item.fileName,
                    originalTitle: item.fileName,
                    thumbnailAlt: item.fileName,
                    description: item.description,
                    download: item.fullDownload,
                    imageSet: [
                        {
                            srcSet: item.landscapeEmbed,
                            media: '(max-width: 1000px)'
                        },
                        {
                            srcSet: item.originalEmbed,
                            media: '(min-width: 1000px)'
                        }
                    ]
                }

            if (asset.original.includes('.tif'))
                asset.original = item.landscapeEmbed;

            this.setState(prevState => ({
                galleryItems: [asset, ...prevState.galleryItems]
            }));
        });
    }


    render() {

        let galleryContent =
            <div className="section">
                <h3 className="heading no-margin">{this.state.title}</h3>
                <div className=" row">
                    <div className="col-md-8">
                        <p className="intro-blk-copy margin-top-btm">{this.state.desc}</p>
                    </div>
                </div>
                <ImageGallery
                    onErrorImageURL={productFallbackImage}
                    showPlayButton={false}
                    lazyLoad={true}
                    thumbnailPosition={this.state.position}
                    items={this.state.galleryItems}
                    showBullets={this.state.bullets}
                    showIndex={true}
                    renderItem={this._customRenderImg.bind(this)} />
            </div>;

        if (this.state.isLoading) {
            galleryContent = <LoaderSection show={true} />;
        }

        return (
            <div>
                {galleryContent}
            </div>
        );
    }
}

export default PhotoGallery;